(function () {
  var DEFAULT_ELIGIBILITY_PANE_CLASS = 'lightbox open';

  angular.module('kareo.ui.shared.directives.k-patient-check-eligibility', [
    'kareo.ui.shared.directives.k-patient-check-eligibility.directive',
    'kareo.ui.shared.directives.k-patient-check-eligibility.services',
    'kareo.ui.shared.modules.featureSet'
  ])
  .controller('PatientCheckEligibilityController', PatientCheckEligibilityController);

  PatientCheckEligibilityController.$inject = ['$scope', 'PatientEligibilityService', 'featureSet'];

  function PatientCheckEligibilityController($scope, PatientEligibilityService, featureSet) {
    var vm = this;
    vm.providers = [];
    vm.isRunningCheck = false;
    vm.eligibilityStatus = undefined;
    vm.eligibilityStatusMessage = '';
    vm.formattedReport = null;
    vm.showEligibilityReport = false;
    vm.hasError = false;
    vm.canCheckEligibility = (!!vm.insurance.planId || !!vm.insurance.policyNumber) && vm.insurance.realTimeEligibilityChecks;
    vm.isPayerSupportsChecks = false;
    vm.toggleProviderPane = false;
    vm.data = {
      selectedValue: 0
    };

    featureSet.load()
      .then((response) => {
        vm.isTherapyAuthEnhancementsEnabled = response['dark-feature.therapy-auth-enhancements'];
      });

    $scope.$watch('vm.insurance.policyNumber', (policyNumber) => {
      vm.canCheckEligibility = !!policyNumber && vm.insurance.realTimeEligibilityChecks;
    });

    $scope.$watch('vm.insurance.planId', (planId) => {
      vm.canCheckEligibility = !!planId && vm.insurance.realTimeEligibilityChecks;
    });

    if (!vm.eligibilityPaneClass) {
      vm.eligibilityPaneClass = DEFAULT_ELIGIBILITY_PANE_CLASS;
    }

    var onSuccess = function (data) {
      vm.hasError = false;
      vm.isRunningCheck = false;
      vm.toggleProviderPane = false;

      vm.eligibilityStatus =
          data.eligibilityStatus.toUpperCase();

      vm.providerId = vm.data.selectedValue;
      vm.eligibilityData = {
        isOccupationalTherapyADAvailable: data.isOccupationalTherapyADAvailable,
        isPhysicalOrSpeechTherapyAEAvailable: data.isPhysicalOrSpeechTherapyAEAvailable,
        maxAllowedTherapyCapAmount: data.maxAllowedTherapyCapAmount,
        occupationTherapyADAmountUsed: data.occupationTherapyADAmountUsed,
        physicalOrSpeechTherapyAEAmountUsed: data.physicalOrSpeechTherapyAEAmountUsed
      };

      if (vm.eligibilityStatus === '1') {
        vm.eligibilityStatusMessage = 'Verified ';
        vm.eligibilityStatusMessageClass = 'success-text';
      } else if (vm.eligibilityStatus === '2') {
        vm.eligibilityStatusMessage = 'Patient not covered.';
        vm.eligibilityStatusMessageClass = 'error-text';
      } else if (vm.eligibilityStatus === '0' || vm.eligibilityStatus === '4') {
        vm.eligibilityStatusMessage = 'Eligibility could not be determined.';
        vm.eligibilityStatusMessageClass = 'warning-text';
      } else if (vm.eligibilityStatus === '5') {
        vm.eligibilityStatusMessage = 'View report for status information.';
        vm.eligibilityStatusMessageClass = '';
      }

      vm.formattedReport = data.formattedReport;
    };
    var onError = function (error) {
      vm.isRunningCheck = false;
      vm.hasError = true;
      vm.eligibilityStatus = undefined;
      vm.eligibilityStatusMessage = '';
    };

    var buildRequest = function () {
      var eligibilityRequest = {};

      eligibilityRequest.providerId =
          vm.data.selectedValue;

      eligibilityRequest.serviceTypeCode = vm.serviceTypeCode;

      eligibilityRequest.insuranceCompanyPlanId =
          vm.insurance.planId;

      eligibilityRequest.policyNumber =
          vm.insurance.policyNumber;

      if (!!vm.patient.firstName) {
        eligibilityRequest.holderFirstName =
            vm.patient.firstName;
      }

      if (!!vm.patient.lastName) {
        eligibilityRequest.holderLastName =
          vm.patient.lastName;
      }

      if (!!vm.patient.genderId) {
        eligibilityRequest.holderGender =
            vm.patient.genderId;
      }

      if (!!vm.patient.dateOfBirth) {
        const dob = vm.patient.dateOfBirth;

        // this is rough, and when we can update all UI's atomically we should enforce consumers passing in valid
        // moments or Dates, but since we can't yet, this hack allows for the three formats UI's are currently
        // passing in:
        // 1. ISO format eg 2017-10-05T00:00:00
        // 2. With slashes eg 10/05/2017
        // 3. Without slashes eg 10052017
        let dobMoment = moment(dob);

        if (!dobMoment.isValid()) {
          const withoutSlashes = `${dob}`.replace('/', '');
          dobMoment = moment(withoutSlashes, 'MMDDYYYY');
        }

        if (dobMoment.isValid()) {
          eligibilityRequest.holderDOB = dobMoment.toISOString();
        }
      }

      eligibilityRequest.patientRelationshipToInsured = '0';
      if (!!vm.patient.patientRelationshipToInsured) {
        eligibilityRequest.patientRelationshipToInsured = vm.patient.patientRelationshipToInsured;
      }

      if (!!vm.patient.patientId && vm.patient.patientId > 0) {
        eligibilityRequest.patientId = vm.patient.patientId;
      }

      return eligibilityRequest;
    };

    PatientEligibilityService
        .getProviders()
        .then((data) => {
          vm.providers = data.data;
        });

    vm.showProviderPane = function () {
      vm.data.selectedValue = 0;
      vm.toggleProviderPane = true;
      vm.canCheckEligibility = false;
    };

    vm.hideProviderPane = function () {
      vm.canCheckEligibility = true;
      vm.toggleProviderPane = false;
    };

    vm.runEligibilityCheckByDetails = function () {
      vm.providerid = vm.data.selectedValue;
      vm.canCheckEligibility = false;
      vm.hasError = false;
      vm.eligibilityStatus = undefined;

      if (!vm.isRunningCheck) {
        vm.isRunningCheck = true;

        // build request
        var request = buildRequest();

        PatientEligibilityService
          .checkEligibility(request)
          .then((data) => {
            onSuccess(data);
          },
          (error) => {
            onError(error);
          });
        vm.toggleProviderPane = false;
      }
    };

    vm.runEligibilityCheckById = function () {
      vm.providerid = vm.data.selectedValue;
      vm.canCheckEligibility = false;

      if (!vm.isRunningCheck) {
        vm.isRunningCheck = true;

        // build request
        vm.eligibilityRequest.providerId =
            vm.data.selectedValue;
        vm.eligibilityRequest.serviceTypeCode = vm.servicetypecode;

        vm.eligibilityRequest.InsuranceCompanyPlanId =
            vm.insurance.planId;
        vm.eligibilityRequest.PolicyNumber =
            vm.insurance.policyNumber;
        vm.eligibilityRequest.patientId =
            vm.patient.patientId;

        PatientEligibilityService
          .checkEligibility(vm.eligibilityRequest)
          .then((data) => {
            onSuccess(data);
          },
          (error) => {
            onError(error);
          });
        vm.toggleProviderPane = false;
      }
    };
  }
})();
